// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"778":"bee7aec0","900":"aa27cb43"}[chunkId] + ".chunk.js";
};